import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toolTipResponse: null,
  confirmationDetailsResponse: null,
  confirmationResponse: null,
  isDepositResponse: false,
  isFileDownloaded: false,
  confirmationNotification: null,
  isUnassignWorkerResponse: false,
  loaderMessage: "",
};

const clientConfirmationSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    getConfirmationToolTipAction: (state, { payload }) => {},
    setConfirmationToolTipAction: (state, { payload }) => {
      state.toolTipResponse = payload;
    },

    updateConfirmationToolTipAction: (state, { payload }) => {},
    setUpdateConfirmationToolTipAction: (state, { payload }) => {
      state.toolTipResponse = payload;
    },

    getConfirmationAction: (state, { payload }) => {},
    setConfirmationAction: (state, { payload }) => {
      state.confirmationDetailsResponse = payload;
    },

    updateConfirmationAction: (state, { payload }) => {},
    setUpdateConfirmationAction: (state, { payload }) => {
      state.confirmationResponse = payload;
    },

    unassignWorkerServiceAction: (state, { payload }) => {},
    unassignServiceResponse: (state, { payload }) => {
      state.isUnassignWorkerResponse = payload;
    },

    getLeadConfirmationLinkAction: (state, { payload }) => {},
    setLeadConfirmationDownloaded: (state, { payload }) => {
      state.isFileDownloaded = payload;
    },

    getConfirmationNotificationAction: (state) => {},
    setConfirmationNotificationAction: (state, { payload }) => {
      state.confirmationNotification = payload;
    },

    cancelInvoiceDepositAction: (state, { payload }) => {},
    setResponseCancelInvoiceDeposit: (state, { payload }) => {
      state.isDepositResponse = payload;
    },

    transferInvoiceDepositAction: (state, { payload }) => {},
    setResponseTransferInvoice: (state, { payload }) => {
      state.isDepositResponse = payload;
    },

    setLoaderMessage: (state, action) => {
      state.loaderMessage = action.payload;
    },
  },
});

const {
  getConfirmationToolTipAction,
  setConfirmationToolTipAction,
  updateConfirmationToolTipAction,
  setUpdateConfirmationToolTipAction,
  getConfirmationAction,
  setConfirmationAction,
  updateConfirmationAction,
  setUpdateConfirmationAction,
  getLeadConfirmationLinkAction,
  setLeadConfirmationDownloaded,
  getConfirmationNotificationAction,
  setConfirmationNotificationAction,
  setLoaderMessage,
  cancelInvoiceDepositAction,
  setResponseCancelInvoiceDeposit,
  transferInvoiceDepositAction,
  setResponseTransferInvoice,
  unassignWorkerServiceAction,
  unassignServiceResponse,
} = clientConfirmationSlice.actions;
export {
  getConfirmationToolTipAction,
  setConfirmationToolTipAction,
  updateConfirmationToolTipAction,
  setUpdateConfirmationToolTipAction,
  getConfirmationAction,
  setConfirmationAction,
  updateConfirmationAction,
  setUpdateConfirmationAction,
  getLeadConfirmationLinkAction,
  setLeadConfirmationDownloaded,
  getConfirmationNotificationAction,
  setConfirmationNotificationAction,
  setLoaderMessage,
  cancelInvoiceDepositAction,
  setResponseCancelInvoiceDeposit,
  transferInvoiceDepositAction,
  setResponseTransferInvoice,
  unassignWorkerServiceAction,
  unassignServiceResponse,
};

export default clientConfirmationSlice.reducer;
